import { Header, Text } from '@crossfit/design-system'
import { Button, Icon } from '@crossfit/ui'
import { DashboardHighlight as Highlight } from 'types'
import style from './style.module.scss'
import { trackEvent } from 'services/segment'
import { useNavigate } from 'react-router'

export type DashboardHighlightProps = {
  highlight: Highlight
  affiliateId: string
  affiliateSlug: string
}

export default function DashboardHighlight({
  highlight: { headlineText, image, bodyText, useCustomLink, link },
}: DashboardHighlightProps) {
  const navigate = useNavigate()
  return (
    <>
      <img src={image?.sizes?.small} alt={headlineText} />
      <div className={style.highlightContent}>
        <Header as='h4' size='sm' className={style.highlightHeadlineText}>
          {headlineText}
        </Header>
        <Text size='sm' className={style.bodyText} type={'body'}>
          {bodyText}
        </Text>

        <Button
          className={style.readMoreButton}
          variant='tertiary'
          as='a'
          target={useCustomLink ? '_blank' : '_self'}
          onClick={() => {
            trackEvent({
              component: 'atk-carousel',
              linkUrl: link.url,
              text: link.text,
              event: 'Button Clicked',
            })
            navigate(link.url)
          }}
          rightIcon={
            <Icon className={style.readMoreButtonIcon} name='arrow-right' />
          }
        >
          {link.text}
        </Button>
      </div>
    </>
  )
}
